var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeroSmall'),_c('b-container',{staticClass:"mt-5 mb-5"},[_c('h1',{staticClass:"display-1"},[_vm._v(_vm._s(this.$route.params.city))])]),_c('Blogs',{attrs:{"tag":this.$route.params.city}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }